import React, { useEffect } from "react"
import firebase from "gatsby-plugin-firebase"
import { login, logout } from "../../../../actions/auth"
import { connect } from "react-redux"
import Styles from "./UserIcon.module.scss"
import Icon from "../../../Icons/Generic/user"
import UserMenu from "./UserMenu"
import { openUserMenu, closeUserMenu } from "../../../../actions/userMenu"

const UserIcon = ({
  userMenuOpen,
  openUserMenu,
  closeUserMenu,
  login,
  logout,
  uid
}) => {
  useEffect(() => {
    const unlisten = firebase.auth().onAuthStateChanged(user => {
      if (user) {
        // User is signed in.
        console.log("User is signed in")
        const { uid, displayName, email, photoURL } = user
        login(uid, displayName, email, photoURL) // if user login detected. action log on and add information to redux state.
        closeUserMenu() // once you log in closes the user menu.
      } else {
        logout() // if user not detected logout
        console.log("No Users Signed In")
      }
    })
    return () => {
      unlisten()
    }
  }, [])

  return (
    <div className={Styles.usericon}>
      <span
        className={`${Styles.userbutton} ${uid ? Styles.authenticated : null}`}
        onClick={() => {
          !userMenuOpen ? openUserMenu() : closeUserMenu()
        }}
      >
        <Icon />
      </span>
      {userMenuOpen ? <UserMenu /> : null}
    </div>
  )
}

const mapDispatchToProps = dispatch => ({
  openUserMenu: () => dispatch(openUserMenu()),
  closeUserMenu: () => dispatch(closeUserMenu()),
  logout: () => dispatch(logout()),
  login: (uid, displayName, email, photoURL) =>
    dispatch(login(uid, displayName, email, photoURL)),
})

const mapStateToProps = state => ({
  uid: state.auth.uid,
  userMenuOpen: state.userMenu.userMenuOpen,
})

// calls to connect
export default connect(mapStateToProps, mapDispatchToProps)(UserIcon)
